import { render, staticRenderFns } from "./consumer.vue?vue&type=template&id=05c56410&scoped=true&"
import script from "./consumer.vue?vue&type=script&lang=js&"
export * from "./consumer.vue?vue&type=script&lang=js&"
import style0 from "./consumer.vue?vue&type=style&index=0&id=05c56410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c56410",
  null
  
)

export default component.exports